module.exports = __webpack_public_path__ + "88211aefe6a8f53d030c82b8e6f79b64.pdf";